<template>
    <div id="password">
        <nav>
            <center>
                <img id="logo" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
        </nav>
        <h1>MOT DE PASSE PERDU</h1>
        <h4>{{ msg }}</h4>
        <input type="text" name="username" v-model="input.username" placeholder="Votre adresse mail..." />
        <button type="button" v-on:click="loginWeweb()">Réinitialiser le mot de passe</button>
    </div>
</template>

<script>

    import axios from 'axios';

    export default {
        name: 'Password',
        data() {
            return {
                input: {
                    username: ""
                },
                msg:""
            }
        },
        methods: {
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "login" });
            },
            async loginWeweb() {
                var response = await axios.put('https://so.gaviota.fr/api/userdata/forgotpassword', 
                    {
                        "user": {
                            "emailAddress": this.input.username.toLocaleLowerCase()
                        }
                    }
                );
                if(response.data.message){
                    this.msg = "Nouveau mot de passe envoyé par e-mail";
                }
            }
        }
    }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #password {
        width: 350px;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        border:none;
        padding-bottom: 20px;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 550;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        display: block;
        text-align: center;
    }
    h4{
        background-color: #ff0000;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 550;
        margin:0;
        font-size: 18px;
        display: block;
        text-align: center;
    }
    input{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: 15px;
        width: 310px;
        padding-left:10px;
        padding-top:5px;
        padding-bottom:3px;
        background-color:rgb(232, 240, 254);
    }
    button{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: 15px;
        width: 320px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        padding-top:3px;
        padding-bottom:3px;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    img{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
</style>